"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Home, Building2, Phone, CheckCircle2 } from "lucide-react";
const apartmentPricing = [{
  id: "apt-epc",
  service: "EPC-keuring",
  price: "€150",
  link: "/EPCCertificatePage"
}, {
  id: "apt-asbestos",
  service: "Asbestattest",
  price: "€475",
  link: "/AsbestosCertificatePage"
}, {
  id: "apt-electrical",
  service: "Elektriciteitskeuring",
  price: "€170",
  link: "/ElectricalInspectionPage"
}];
const housePricing = [{
  id: "house-epc",
  service: "EPC-keuring",
  price: "€175",
  link: "/EPCCertificatePage"
}, {
  id: "house-asbestos",
  service: "Asbestattest",
  price: "€525",
  link: "/AsbestosCertificatePage"
}, {
  id: "house-electrical",
  service: "Elektriciteitskeuring",
  price: "€170",
  link: "/ElectricalInspectionPage"
}];
export default function Prijzen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-[600px] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/geometric_texture_light_canvas.png)] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h1 className="text-5xl font-bold text-foreground mb-6">
            Duidelijke Prijzen, Geen Verrassingen
          </h1>
          <p className="text-muted-foreground mb-6 max-w-3xl mx-auto !font-bold !text-2xl">Bel ons direct of vraag online een keuring aan. BTW, stalen en alle kosten inbegrepen!</p>
          <div className="inline-flex items-center gap-2 bg-secondary text-secondary-foreground px-6 py-3 rounded-md font-bold text-lg shadow-medium mb-8">
            <CheckCircle2 className="size-5" />
            <span>Alle stalen inbegrepen in de prijs</span>
          </div>
        </div>

        {}
        <div className={`bg-primary text-primary-foreground rounded-lg p-8 mb-16 text-center shadow-medium transition-all duration-[250ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "50ms"
      }}>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3">
              <Phone className="size-8" />
              <div className="text-left">
                <p className="text-sm opacity-90">Bel ons nu voor direct advies</p>
                <Link to="tel:+32123456789" className="text-3xl font-bold hover:underline">0487412206</Link>
              </div>
            </div>
            <div className="hidden md:block w-px h-16 bg-primary-foreground/30"></div>
            <p className="text-lg max-w-md">
              Onze experts staan klaar om al uw vragen te beantwoorden en uw keuring te plannen
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {}
          <div className={`transition-all duration-[250ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "100ms"
        }}>
            <div className="flex items-center justify-center gap-3 mb-8">
              <Building2 className="size-8 text-primary" />
              <h2 className="text-3xl font-semibold text-foreground">
                Appartement Tarieven
              </h2>
            </div>
            <div className="space-y-6">
              {apartmentPricing.map((item, i) => <div key={item.id} data-index={i} className="bg-background border border-border-light rounded-md shadow-soft p-6 hover:shadow-medium hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)]">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold text-foreground">
                      {item.service}
                    </h3>
                    <span className="text-2xl font-bold text-primary">
                      {item.price}
                    </span>
                  </div>
                  <Link to={item.link}>
                    <Button size="sm" className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.04] active:bg-primary-active focus-visible:ring-primary/40 transition-all duration-[120ms] ease-in-out">
                      Direct aanvragen
                    </Button>
                  </Link>
                </div>)}
            </div>
          </div>

          {}
          <div className={`transition-all duration-[250ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "200ms"
        }}>
            <div className="flex items-center justify-center gap-3 mb-8">
              <Home className="size-8 text-primary" />
              <h2 className="text-3xl font-semibold text-foreground">
                Huis Tarieven
              </h2>
            </div>
            <div className="space-y-6">
              {housePricing.map((item, i) => <div key={item.id} data-index={i} className="bg-background border border-border-light rounded-md shadow-soft p-6 hover:shadow-medium hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)]">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold text-foreground">
                      {item.service}
                    </h3>
                    <span className="text-2xl font-bold text-primary">
                      {item.price}
                    </span>
                  </div>
                  <Link to={item.link}>
                    <Button size="sm" className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.04] active:bg-primary-active focus-visible:ring-primary/40 transition-all duration-[120ms] ease-in-out">
                      Direct aanvragen
                    </Button>
                  </Link>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}